import filesFromFolder from "./getFilesFromFolder";
import { getFileExtension } from "../utils/fileHelpers";
import getSignedURL from "./getSignedURL";

const getAllURLs = async (files) => {
  let URLs = [];

  for (const file of files) {
    const { id } = file;
    const keys = await filesFromFolder(id, true);

    for (const key of keys) {
      const ext = getFileExtension(key);
      if (ext === "pdf") {
        const downloadableURL = await getSignedURL(key);
        URLs.push(downloadableURL);
      }
    }
  }

  return URLs;
};

export default getAllURLs;
